var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMailCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500488,
    y: 0.560059,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5005 9.21006V16.9101C20.5005 17.8213 19.7256 18.5601 18.7697 18.5601H7.23126C6.27538 18.5601 5.50049 17.8213 5.50049 16.9101V9.21006M20.5005 9.21006C20.5005 8.29879 19.7256 7.56006 18.7697 7.56006H7.23126C6.27538 7.56006 5.50049 8.29879 5.50049 9.21006M20.5005 9.21006V9.38805C20.5005 9.96103 20.1887 10.493 19.6768 10.7933L13.9076 14.1779C13.3513 14.5042 12.6497 14.5043 12.0934 14.1779L6.32417 10.7933C5.8123 10.493 5.50049 9.96103 5.50049 9.38805V9.21006",
    stroke: "#2A9DF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMailCircle);
export default __webpack_public_path__ + "static/media/ic-mail-circle.82c3c27483b7c72b44666c6d612a82c0.svg";
export { ForwardRef as ReactComponent };